import { WhatsappLogo } from "@phosphor-icons/react";

const PHONE = "919986143554";
const MESSAGE = encodeURIComponent(
  "Hi Unicators, I'd like admission guidance for MBBS/BDS/Nursing. Please help me.",
);

// Global floating WhatsApp enquiry button — sits just above the Jimmy
// assistant launcher (which lives at bottom-5 right-5, h-16).
export default function WhatsAppButton() {
  return (
    <a
      href={`https://wa.me/${PHONE}?text=${MESSAGE}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-float-btn"
      className="fixed bottom-[92px] right-5 z-[60] w-14 h-14 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366]/30" style={{ animation: "emmyPulse 2.2s ease-in-out infinite" }} />
      <span className="absolute inset-0 rounded-full bg-[#25D366] shadow-lg flex items-center justify-center group-hover:scale-105 transition-transform">
        <WhatsappLogo size={30} weight="fill" className="text-white" />
      </span>
    </a>
  );
}
